import { tw } from "@careinfo/tailwind";
import React from "react";
import Button from "../Reusable/Button";

const CargoInvoicePopup = (props: any) => {
  const {
    handleCreate,
    isLoading,
    user,
    setError,
    getValues,
    invoiceReport,
    setData,
  } = props;

  return (
    <>
      <>
        <div className="flex justify-between mt-10">
          <div>Total Number of order:</div>
          <div>{invoiceReport?.totalOrder}</div>
        </div>
        <div className="flex justify-between mt-2">
          <div>Total Tax Amount:</div>
          <div>{invoiceReport?.tax_amount ?? 0}</div>
        </div>
        <div className="flex justify-between mt-2">
          <div>Total Amount After Tax:</div>
          <div>{Number(invoiceReport?.totalAmount)}</div>
        </div>
        <div className="flex justify-between mt-2 font-bold">
          <div>Net Payable</div>
          <div>{Number(invoiceReport?.totalAmount)}</div>
        </div>
        <div className={tw`mx-auto`}>
          <div className={tw`w-40`}>
            <Button
              label={"Generate Statement"}
              isLoading={isLoading}
              onClick={() => {
                handleCreate(user, getValues(), setError);
                setData([]);
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};
export default CargoInvoicePopup;
